import { useCallback } from 'react';
import { RegenerationHistoryItem } from './useRegenerateTracking';

interface UseEditWithRegenerationHandlingProps {
  originalHandleEdit: (messageId: string, content: string) => Promise<void>;
  regenerationHistory: RegenerationHistoryItem[];
  handleEditRegeneratedMessage: (messageId: string) => void;
  completeEdit: (messageId: string) => void;
}

export const useEditWithRegenerationHandling = ({
  originalHandleEdit,
  regenerationHistory,
  handleEditRegeneratedMessage,
  completeEdit
}: UseEditWithRegenerationHandlingProps) => {
  
  // Enhanced handleEdit that coordinates with regeneration tracking
  const handleEdit = useCallback(async (messageId: string, content: string) => {
    try {
      // Check if this message has regeneration history
      const hasRegenerationHistory = regenerationHistory.some(item => item.messageId === messageId);
      
      if (hasRegenerationHistory) {
        // Mark message as being edited to prevent regeneration tracking
        handleEditRegeneratedMessage(messageId);
      }
      
      // Call the original edit function
      await originalHandleEdit(messageId, content);
      
      // After edit completes, update regeneration tracking
      if (hasRegenerationHistory) {
        completeEdit(messageId);
      }
    } catch (error) {
      console.error('Error in handleEdit:', error);
      throw error;
    }
  }, [originalHandleEdit, regenerationHistory, handleEditRegeneratedMessage, completeEdit]);

  return { handleEdit };
};

export default useEditWithRegenerationHandling; 